import { __assign, __makeTemplateObject, __rest } from "tslib";
/** @jsx jsx */

/** @jsxFrag */

import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';
import { css, jsx } from '@emotion/react';
import { useTheme } from './theme/Providers';
import { safeBind } from './hooks/compose-bind';
import FlagsStyles from './utils/countrys';
import { searchCountry, formatCurrency, formatPhone, formatDate } from './utils/inputs';
import countries from './utils/codes.json';
var DEFAULT_COUNTRY = {
  name: 'México',
  flag: '🇲🇽',
  code: 'MX',
  dialCode: '+52'
};
var eraseImg = jsx("svg", {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, jsx("path", {
  d: 'M14 2L2 14',
  stroke: '#021215',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}), jsx("path", {
  d: 'M2 2L14 14',
  stroke: '#021215',
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
}));
var arrowDown = jsx("svg", {
  "data-selectbox": true,
  width: '24',
  height: '24',
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg'
}, jsx("g", {
  id: 'chevron-down'
}, jsx("path", {
  id: 'Path 3',
  d: 'M6 10L12 16L18 10',
  stroke: '#021215',
  strokeLinecap: 'square'
})));

var setFocusNextInput = function setFocusNextInput(key, value, error) {
  if (key === 'Enter' && value && !error) {
    var inputs = document.querySelectorAll('input');
    var len = inputs.length - 1;
    var i = 0;

    while (i < len) {
      if (inputs[i++] === document.activeElement) {
        inputs[i].focus();
        break;
      }
    }
  }
};

var phonePlaceholder = '(00) 000 000 00';

var getColor = function getColor(disabled, theme, baseColor, isDarkMode, isNone) {
  var scales = theme.colors.scales;
  return disabled ? isDarkMode ? scales.grayShades[5] : scales.grayShades[11] : isNone ? theme.colors.text.default : baseColor;
}; // variations to the underline input based on intent


var InputIntents = function InputIntents(theme, intent, disabled, variant) {
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: block;\n    background: none;\n    border: none;\n    border-radius:0;\n    -webkit-appearance: none;\n    width:80%;\n    margin-left: ", ";\n    -webkit-border-radius:0;\n    color: ", ";\n    outline: none;\n    font-size: ", ";\n    z-index: 1;\n    &::placeholder\xA0{\n      color: ", ";\n    }\n    &:hover {\n      border-color: ", ";\n    }    \n    \n    &:focus {\n      border-color: ", ";\n    }\n\n    &:focus-within {\n      border-color: ", ";\n    }\n\n    &:disabled, &:disabled::placeholder {\n      -webkit-text-fill-color: ", "; \n      opacity: 1;\n      } \n    }    \n  "], ["\n    display: block;\n    background: none;\n    border: none;\n    border-radius:0;\n    -webkit-appearance: none;\n    width:80%;\n    margin-left: ", ";\n    -webkit-border-radius:0;\n    color: ", ";\n    outline: none;\n    font-size: ", ";\n    z-index: 1;\n    &::placeholder\xA0{\n      color: ", ";\n    }\n    &:hover {\n      border-color: ", ";\n    }    \n    \n    &:focus {\n      border-color: ", ";\n    }\n\n    &:focus-within {\n      border-color: ", ";\n    }\n\n    &:disabled, &:disabled::placeholder {\n      -webkit-text-fill-color: ", "; \n      opacity: 1;\n      } \n    }    \n  "])), variant === 'country' ? '2rem' : '0.313rem', disabled ? theme.colors.scales.grayShades[3] : theme.colors.text.default, theme.fontSizes[2], disabled ? theme.colors.scales.grayShades[3] : theme.colors.text.default, theme.colors.intent[intent].base, theme.colors.intent[intent].base, theme.colors.intent[intent].base, disabled ? theme.colors.scales.grayShades[3] : theme.colors.text.default);
};

var HelperStyles = function HelperStyles(theme, color) {
  return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: block;\n    position: absolute;\n    box-sizing: border-box;\n    font-weight: ", ";\n    line-height: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    color: ", ";\n    margin-left: 0.313rem;\n    top: 2.65rem;\n  "], ["\n    display: block;\n    position: absolute;\n    box-sizing: border-box;\n    font-weight: ", ";\n    line-height: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    color: ", ";\n    margin-left: 0.313rem;\n    top: 2.65rem;\n  "])), theme.fontWeights.body, theme.lineHeights.caption, theme.fonts.base, theme.fontSizes[1], color);
};

var AnimationStyles = function AnimationStyles(theme, intent) {
  var dark = theme.colors.mode === 'dark';
  var base = intent === 'none' ? theme.colors.text.default : theme.colors.intent[intent].base;

  if (dark) {
    base = theme.colors.intent[intent].light;
  }

  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width:fit-content;\n    display: block;\n    position: absolute;\n    top:-0.75rem;\n    box-sizing: border-box;\n    font-weight: ", ";\n    line-height: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    color: ", ";\n    margin-left: 0.313rem;\n    transform: translateY(0rem);\n    transition: all 0.2s linear;\n    background-color:", ";\n    z-index:99999;\n  "], ["\n    width:fit-content;\n    display: block;\n    position: absolute;\n    top:-0.75rem;\n    box-sizing: border-box;\n    font-weight: ", ";\n    line-height: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    color: ", ";\n    margin-left: 0.313rem;\n    transform: translateY(0rem);\n    transition: all 0.2s linear;\n    background-color:", ";\n    z-index:99999;\n  "])), theme.fontWeights.body, theme.lineHeights.caption, theme.fonts.base, theme.fontSizes[1], base, dark ? '#1c2a2c' : 'white');
};

var CountryPhoneStyles = function CountryPhoneStyles(theme, label, variant, intent) {
  var base = intent === 'none' ? theme.colors.text.default : theme.colors.intent[intent].base;
  var dark = theme.colors.mode === 'dark';

  if (dark) {
    base = theme.colors.intent[intent].light;
  }

  return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    background:white;\n    font-size: ", ";\n    font-family: ", ";\n    margin-left: 0.313rem;\n    margin-bottom: ", ";\n    color: ", ";\n  "], ["\n    background:white;\n    font-size: ", ";\n    font-family: ", ";\n    margin-left: 0.313rem;\n    margin-bottom: ", ";\n    color: ", ";\n  "])), theme.fontSizes[1], theme.fonts.base, label ? variant === 'phone' ? '0.5rem' : '0.2rem' : '0', base);
};

var LabelStyles = function LabelStyles(theme, intent) {
  var base = intent === 'none' ? theme.colors.text.default : theme.colors.intent[intent].base;
  var dark = theme.colors.mode === 'dark';

  if (dark) {
    base = theme.colors.intent[intent].light;
  }

  return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width:fit-content;\n    display: inline-block;\n    position: relative;\n    box-sizing: border-box;\n    bottom: 0.313rem;\n    font-weight: ", ";\n    line-height: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    color: ", ";\n    margin-left: 0.313rem;\n    z-index: 0;\n    transform: translateY(1.05rem);\n    transition: all 0.2s linear;\n  "], ["\n    width:fit-content;\n    display: inline-block;\n    position: relative;\n    box-sizing: border-box;\n    bottom: 0.313rem;\n    font-weight: ", ";\n    line-height: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    color: ", ";\n    margin-left: 0.313rem;\n    z-index: 0;\n    transform: translateY(1.05rem);\n    transition: all 0.2s linear;\n  "])), theme.fontWeights.body, theme.lineHeights.caption, theme.fonts.base, theme.fontSizes[2], base);
};

var Label = function Label(_a) {
  var id = _a.id,
      theme = _a.theme,
      label = _a.label,
      intent = _a.intent,
      variant = _a.variant,
      placeholder = _a.placeholder,
      animation = _a.animation,
      defaultValue = _a.defaultValue,
      value = _a.value,
      labelStyles = _a.labelStyles;
  var gettedLabelStyles = LabelStyles(theme, intent);
  var animationStyles = AnimationStyles(theme, intent);
  var countryPhoneStyles = CountryPhoneStyles(theme, true, variant, intent);

  if (variant === 'default' || variant === 'currency' || variant === 'select') {
    return jsx("label", {
      htmlFor: id,
      css: [animation || value || defaultValue || placeholder ? animationStyles : gettedLabelStyles, __assign({}, labelStyles)]
    }, label);
  } else if (variant === 'country' || variant === 'phone' || variant === 'date') {
    return jsx("label", {
      htmlFor: id,
      css: [countryPhoneStyles, value || animation || placeholder || variant === 'phone' ? animationStyles : gettedLabelStyles, __assign({}, labelStyles)]
    }, label);
  } else {
    return jsx("label", {
      htmlFor: id,
      css: [animation ? animationStyles : gettedLabelStyles, __assign({}, labelStyles)]
    }, label);
  }
};

export var InputTextComponent = function InputTextComponent(_a, ref) {
  var _b, _c;

  var id = _a.id,
      label = _a.label,
      helper = _a.helper,
      placeholder = _a.placeholder,
      variant = _a.variant,
      _d = _a.intent,
      intent = _d === void 0 ? 'none' : _d,
      _e = _a.component,
      Component = _e === void 0 ? 'div' : _e,
      _f = _a.disabled,
      disabled = _f === void 0 ? false : _f,
      caption = _a.caption,
      iconAfter = _a.iconAfter,
      mask = _a.mask,
      _g = _a.countryCode,
      countryCode = _g === void 0 ? 'MX' : _g,
      value = _a.value,
      defaultValue = _a.defaultValue,
      error = _a.error,
      focusOnDisplay = _a.focusOnDisplay,
      autoFocusDelay = _a.autoFocusDelay,
      autoFocusIndex = _a.autoFocusIndex,
      labelStyles = _a.labelStyles,
      inputStyles = _a.inputStyles,
      helperStyles = _a.helperStyles,
      inputCss = _a.inputCss,
      _onFocus = _a.onFocus,
      _onBlur = _a.onBlur,
      onChange = _a.onChange,
      onClickAfterIcon = _a.onClickAfterIcon,
      setEraseValue = _a.setEraseValue,
      onSelectItem = _a.onSelectItem,
      onOpenSelected = _a.onOpenSelected,
      onCloseSelected = _a.onCloseSelected,
      dropdownIndex = _a.dropdownIndex,
      iconAfterCss = _a.iconAfterCss,
      iconBeforeCss = _a.iconBeforeCss,
      openCountry = _a.openCountry,
      initItems = _a.initItems,
      onArrowInteraction = _a.onArrowInteraction,
      rest = __rest(_a, ["id", "label", "helper", "placeholder", "variant", "intent", "component", "disabled", "caption", "iconAfter", "mask", "countryCode", "value", "defaultValue", "error", "focusOnDisplay", "autoFocusDelay", "autoFocusIndex", "labelStyles", "inputStyles", "helperStyles", "inputCss", "onFocus", "onBlur", "onChange", "onClickAfterIcon", "setEraseValue", "onSelectItem", "onOpenSelected", "onCloseSelected", "dropdownIndex", "iconAfterCss", "iconBeforeCss", "openCountry", "initItems", "onArrowInteraction"]);

  var phoneValue = '';
  var formatted = '';

  if (variant === 'phone' && (value || defaultValue)) {
    var countryFound = searchCountry(countryCode);

    if (countryFound) {
      var dialCode_1 = countryFound.dialCode;
      var formattedPhone = formatPhone(dialCode_1 + (value || defaultValue), dialCode_1.length);
      phoneValue = formattedPhone;
    }
  }

  if (variant === 'country') {
    value = (_b = searchCountry(countryCode)) === null || _b === void 0 ? void 0 : _b.name;
  }

  if (variant === 'currency' && defaultValue) {
    formatted = formatCurrency(defaultValue, true);
    if (!value) value = formatted;
  }

  if (variant === 'currency' && value) {
    formatted = formatCurrency(value, true);
    value = formatted;
  }

  var theme = useTheme();

  var _h = React.useState(''),
      dialCode = _h[0],
      setDialCode = _h[1];

  var _j = React.useState(value || ''),
      inputValue = _j[0],
      setInputValue = _j[1];

  var _k = React.useState(formatted !== '' ? formatted : phoneValue),
      inputDisplayedValue = _k[0],
      setInputDisplayedValue = _k[1];

  var _l = useState(false),
      isFocused = _l[0],
      setIsFocused = _l[1];

  var _m = useState(false),
      animation = _m[0],
      setAnimation = _m[1];

  var _o = useState(intent ? intent : 'none'),
      intentState = _o[0],
      setIntent = _o[1];

  var _p = useState(false),
      opened = _p[0],
      setOpened = _p[1];

  var notIntent = intent === 'none';
  var isDarkMode = theme.colors.mode === 'dark';
  var country = searchCountry(countryCode); // const countryObj = countries.find(cty => cty.code === countryCode)

  var _q = React.useState(DEFAULT_COUNTRY),
      countryInput = _q[0],
      setCountryInput = _q[1];

  var brandColor = notIntent ? theme.colors.intent.none : theme.colors.intent[intent];
  var base = brandColor.base;
  var color = getColor(disabled, theme, base, isDarkMode, notIntent);
  var gettedHelperStyles = HelperStyles(theme, color);
  var gettedInputStyles = InputIntents(theme, intentState, disabled, variant);
  var captionStyles = css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    position: absolute;\n    font-size: ", ";\n    font-family: ", ";\n    color: ", ";\n    top: ", ";\n    right:  ", ";\n  "], ["\n    position: absolute;\n    font-size: ", ";\n    font-family: ", ";\n    color: ", ";\n    top: ", ";\n    right:  ", ";\n  "])), theme.fontSizes[2], theme.fonts.base, disabled ? theme.colors.scales.grayShades[3] : theme.colors.text.default, label ? '0.75rem' : '0.063rem', value && value.length > 0 ? '2.4rem' : '0.4375rem');
  var iconAfterStyles = css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: inline-block;\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    overflow: hidden;\n    cursor: ", ";\n    z-index: 1;\n    svg {\n      path {\n        stroke: ", ";\n      }\n    }\n  "], ["\n    display: inline-block;\n    position: absolute;\n    top: ", ";\n    right: ", ";\n    overflow: hidden;\n    cursor: ", ";\n    z-index: 1;\n    svg {\n      path {\n        stroke: ", ";\n      }\n    }\n  "])), label ? variant === 'phone' ? '0.7rem' : '.4rem' : '.7rem', value && variant !== 'country' ? '2rem' : '0.875rem', !disabled ? 'pointer' : '', isDarkMode ? theme.colors.scales.grayShades[0] : theme.colors.scales.grayShades[9]);
  var iconAfterStylesErase = css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      display: inline-block;\n      position: absolute;\n      top: ", ";\n      right: 0.875rem;\n      overflow: hidden;\n      cursor: pointer;\n      z-index: 1;\n      svg {\n        path {\n          stroke: ", ";\n        }\n      }\n    "], ["\n      display: inline-block;\n      position: absolute;\n      top: ", ";\n      right: 0.875rem;\n      overflow: hidden;\n      cursor: pointer;\n      z-index: 1;\n      svg {\n        path {\n          stroke: ", ";\n        }\n      }\n    "])), label ? variant === 'phone' ? '0.7rem' : '.8rem' : '.8rem', isDarkMode ? theme.colors.scales.grayShades[0] : theme.colors.scales.grayShades[9]);
  var iconBeforeStyles = css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    position: absolute;\n    top: ", ";\n    left: 0.313rem;\n    overflow: hidden;\n    cursor: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    color: ", ";\n    font-style: normal;\n    width: ", ";\n    z-index: 2;\n    svg {\n      display: inline;\n      width: 0.375rem;\n      margin: 0rem 0.2rem;\n      path {\n        stroke: ", ";\n        stroke-width: 0.25rem;\n      }\n    }\n    select {\n      font-size: 0.875rem;\n      font-family: ", ";\n      background: none;\n      cursor: pointer;\n      border: none;\n      -webkit-appearance: listbox;\n      -moz-appearance: listbox;\n      border: 0 !important;\n      width: ", ";\n    }\n  "], ["\n    position: absolute;\n    top: ", ";\n    left: 0.313rem;\n    overflow: hidden;\n    cursor: ", ";\n    font-family: ", ";\n    font-size: ", ";\n    color: ", ";\n    font-style: normal;\n    width: ", ";\n    z-index: 2;\n    svg {\n      display: inline;\n      width: 0.375rem;\n      margin: 0rem 0.2rem;\n      path {\n        stroke: ", ";\n        stroke-width: 0.25rem;\n      }\n    }\n    select {\n      font-size: 0.875rem;\n      font-family: ", ";\n      background: none;\n      cursor: pointer;\n      border: none;\n      -webkit-appearance: listbox;\n      -moz-appearance: listbox;\n      border: 0 !important;\n      width: ", ";\n    }\n  "])), label ? variant === 'phone' ? '1.51rem' : variant === 'country' ? '0.6rem' : '.91rem' : '0.85rem', variant === 'phone' ? 'pointer' : 'inherit', theme.fonts.base, theme.fontSizes[2], disabled ? theme.colors.scales.grayShades[3] : theme.colors.text.default, variant === 'phone' ? '2.125rem' : '1.125rem', disabled ? theme.colors.scales.grayShades[3] : theme.colors.text.default, theme.fonts.base, variant === 'phone' ? '2.125rem' : '1.125rem');

  var handlePhoneKey = function handlePhoneKey(value) {
    var _a;

    var isOnlyCode = false;
    var inBluredCode = (_a = searchCountry(dialCode ? dialCode : countryCode)) === null || _a === void 0 ? void 0 : _a.dialCode;
    var formatted = formatPhone(value, inBluredCode === null || inBluredCode === void 0 ? void 0 : inBluredCode.length);

    if (formatted.length <= "".concat(inBluredCode, " ").length) {
      formatted = "".concat(inBluredCode, " ");
      isOnlyCode = true;
    }

    setInputDisplayedValue(formatted);
    return {
      isOnlyCode: isOnlyCode,
      length: formatted.length
    };
  };

  var handleDateKey = function handleDateKey(value) {
    var formatted = formatDate(value);
    setInputDisplayedValue(formatted);
    return formatted.length - 1;
  };

  var handleCurrencyKeyDown = function handleCurrencyKeyDown(value) {
    var formatted = formatCurrency(value, false);
    setInputDisplayedValue(formatted);
    return formatted === null || formatted === void 0 ? void 0 : formatted.length;
  };

  var handleCurrencyBlur = function handleCurrencyBlur() {
    if (inputDisplayedValue) {
      var formatted_1 = formatCurrency(inputDisplayedValue, true);
      setInputDisplayedValue(formatted_1);
      setInputValue(inputValue + '.00');
    }
  };

  var handleDialCodeChange = function handleDialCodeChange(option) {
    var _a;

    setCountryInput(option);

    if (option !== null && option.code) {
      setDialCode(option.code);

      if (inputDisplayedValue && inputValue) {
        var formattedPhone = formatPhone(value || defaultValue, (_a = searchCountry(countryCode)) === null || _a === void 0 ? void 0 : _a.dialCode.length);
        setInputDisplayedValue(formattedPhone);
        setFocusNextInput('Enter', inputValue, error);
      }
    }
  };

  var countryContainerCss = css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    padding: 0;\n    bottom: 0;\n    width: 3rem;\n    cursor: pointer;\n  "], ["\n    padding: 0;\n    bottom: 0;\n    width: 3rem;\n    cursor: pointer;\n  "])));

  var handleChange = function handleChange(e) {
    var value = e.target.value;
    var isOnlyCode = false;
    var inputLength;
    var key = e.nativeEvent.inputType === 'deleteContentBackward' ? 'Backspace' : e.nativeEvent.data || e.nativeEvent.target.id;

    if (variant === 'currency' && key) {
      inputLength = handleCurrencyKeyDown(value);
    }

    if (variant === 'phone' && key) {
      var phoneData = handlePhoneKey(value);
      isOnlyCode = phoneData.isOnlyCode;
      inputLength = phoneData.length;
    }

    if (variant === 'date' && key) {
      inputLength = handleDateKey(value);
    }

    var caretStart = e.target.selectionStart;
    var caretEnd = e.target.selectionEnd;

    if (variant === 'currency' && key) {
      inputLength = handleCurrencyKeyDown(value);
    }

    if (variant === 'phone' && key) {
      var phoneData = handlePhoneKey(value);
      isOnlyCode = phoneData.isOnlyCode;
      inputLength = phoneData.length;
    }

    if (variant === 'date' && key) {
      inputLength = handleDateKey(value);
    }

    if (inputLength === caretStart && variant === 'date') {
      caretStart = inputLength + 1;
      caretEnd = inputLength + 1;
    }

    if (inputLength === caretStart + 1 && variant === 'currency') {
      caretStart = inputLength + 1;
      caretEnd = inputLength + 1;
    }

    if (inputLength === caretStart + 1 || inputLength === caretStart + 2 && variant === 'phone') {
      caretStart = inputLength + 1;
      caretEnd = inputLength + 1;
    }

    if (isOnlyCode) {
      caretStart = inputDisplayedValue.length;
      caretEnd = inputDisplayedValue.length;
    }

    if (onChange) onChange(e);
    setTimeout(function () {
      e.target.setSelectionRange(caretStart, caretEnd);
    }, 0);
  };

  var handlePhoneFocused = function handlePhoneFocused() {
    var _a;

    if (variant === 'phone') {
      var inFocusedCode = (_a = searchCountry(dialCode ? dialCode : countryCode)) === null || _a === void 0 ? void 0 : _a.dialCode;

      if (inputDisplayedValue === '') {
        setInputDisplayedValue("".concat(inFocusedCode, " "));
      }
    }
  };

  var handlePhoneBlured = function handlePhoneBlured() {
    var _a;

    if (variant === 'phone') {
      var inBluredCode = (_a = searchCountry(dialCode ? dialCode : countryCode)) === null || _a === void 0 ? void 0 : _a.dialCode;

      if (inputDisplayedValue === "".concat(inBluredCode, " ")) {
        setInputDisplayedValue('');
      }
    }
  };

  var handleArrowInteraction = function handleArrowInteraction(id, value) {
    var newValue = typeof value !== 'undefined' ? value : !opened;

    if (onArrowInteraction) {
      onArrowInteraction(newValue, id);
    }

    setOpened(newValue);
  };

  useEffect(function () {
    var timer;

    if (focusOnDisplay) {
      timer = setTimeout(function () {
        var inputs = document.querySelectorAll('input');
        if (inputs[autoFocusIndex || 0]) inputs[autoFocusIndex || 0].focus();
      }, autoFocusDelay || 1500);
    }

    return function () {
      return clearTimeout(timer);
    };
  }, [focusOnDisplay, autoFocusIndex, autoFocusDelay]);
  useEffect(function () {
    var timer;

    if (isFocused) {
      setIntent('info');
      timer = setTimeout(function () {
        return setAnimation(true);
      }, 200);
    } else {
      setAnimation(false);
      setIntent(intent);
    }

    return function () {
      return clearTimeout(timer);
    };
  }, [isFocused, intent]);
  useEffect(function () {
    if (window) {
      window.addEventListener('click', function (e) {
        var selectBox = document.querySelectorAll('[data-selectbox]');

        if (selectBox !== null) {
          var selectIsClicked_1 = false;
          selectBox.forEach(function (select) {
            if (select.contains(e.target)) {
              selectIsClicked_1 = true;
              return;
            }
          });

          if (!selectIsClicked_1) {
            handleArrowInteraction(String(id), false);
          }
        }
      });
    }
  }, []);
  var controledCountryProp = openCountry !== undefined ? {
    menuIsOpen: openCountry
  } : {};
  var countryStyles = React.useMemo(function () {
    return {
      dropdownIndicator: function dropdownIndicator(base) {
        return __assign(__assign({}, base), {
          margin: '0',
          padding: '0 0.2rem'
        });
      },
      control: function control(base) {
        return __assign(__assign({}, base), {
          bottom: '-0.7rem !important',
          borderWidth: 0
        });
      },
      container: function container(base) {
        return __assign(__assign({}, base), {
          position: 'absolute'
        });
      },
      menuList: function menuList(base) {
        return __assign(__assign({}, base), {
          overflowY: 'scroll'
        });
      },
      menu: function menu(base) {
        return __assign(__assign({}, base), {
          zIndex: dropdownIndex ? dropdownIndex : 9,
          backgroundColor: theme.colors.background.layer
        });
      },
      option: function option(base) {
        return __assign({}, base);
      }
    };
  }, [theme.colors.background.layer]);
  var selectComponents = React.useMemo(function () {
    // ValueContainer 
    var SelectValueContainer = function SelectValueContainer(props) {
      var valueContainerCss = css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n        padding: 0 !important;\n        display: flex;\n        justify-content: flex-end;\n        flex-wrap: nowrap !important;\n        align-items: center;\n      "], ["\n        padding: 0 !important;\n        display: flex;\n        justify-content: flex-end;\n        flex-wrap: nowrap !important;\n        align-items: center;\n      "])));
      return jsx(components.ValueContainer, __assign({
        css: valueContainerCss
      }, props), props.children);
    }; // MenuList


    var SelectMenuList = function SelectMenuList(props) {
      var menuListCss = css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n        padding: 0.2rem;\n        width: 4rem !important;\n      "], ["\n        padding: 0.2rem;\n        width: 4rem !important;\n      "])));
      return jsx(components.MenuList, __assign({
        css: menuListCss,
        className: 'f16'
      }, props), props.children);
    }; // Input


    var SelectInput = function SelectInput(props) {
      var inputCss = css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n        ", "\n        width: 3rem;\n        padding: 0 !important;\n        margin: 0 !important;\n      "], ["\n        ", "\n        width: 3rem;\n        padding: 0 !important;\n        margin: 0 !important;\n      "])), countryContainerCss);
      return jsx(components.Input, __assign({
        css: inputCss
      }, props), props.children);
    }; // Control


    var SelectControl = function SelectControl(props) {
      var controlCss = css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n        padding: 0;\n        width: 3rem;\n        cursor: pointer;\n        position: relative;\n        min-height: 0 !important;\n        z-index: 2;\n        cursor: pointer !important;\n      "], ["\n        padding: 0;\n        width: 3rem;\n        cursor: pointer;\n        position: relative;\n        min-height: 0 !important;\n        z-index: 2;\n        cursor: pointer !important;\n      "])));
      return jsx(components.Control, __assign({
        css: controlCss,
        className: 'f16'
      }, props), props.children);
    }; // Option


    var SelectOption = function SelectOption(props) {
      var _a = props.data.code,
          code = _a === void 0 ? '' : _a;
      var optionCss = css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n        padding: 0 !important;\n        margin: 0 !important;\n        line-height: 1rem !important;\n        padding-left: 1.5rem !important;\n        z-index: 2;\n        width: 2.8rem !important;\n        font-size: ", " !important;\n        font-family: ", " !important;\n        color: ", " !important;\n        &:hover {\n          font-weight: 500 !important;\n        }\n      "], ["\n        padding: 0 !important;\n        margin: 0 !important;\n        line-height: 1rem !important;\n        padding-left: 1.5rem !important;\n        z-index: 2;\n        width: 2.8rem !important;\n        font-size: ", " !important;\n        font-family: ", " !important;\n        color: ", " !important;\n        &:hover {\n          font-weight: 500 !important;\n        }\n      "])), theme.fontSizes[0], theme.fonts.base, theme.colors.text.default);
      var optionContainerCss = css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n        padding-top: 0.2rem;\n        width: 2.5rem;\n      "], ["\n        padding-top: 0.2rem;\n        width: 2.5rem;\n      "])));
      var optionClassName = "flag ".concat(code.toLowerCase());
      return jsx("div", {
        css: optionContainerCss
      }, jsx(components.Option, __assign({
        className: optionClassName,
        css: optionCss
      }, props), props.children));
    }; // single value


    var SelectSingleValue = function SelectSingleValue(props) {
      var code = props.data.code;
      var singleValueCss = css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n        font-size: ", ";\n        font-family: ", " !important; \n      "], ["\n        font-size: ", ";\n        font-family: ", " !important; \n      "])), theme.fontSizes[0], theme.fonts.base);
      var classNameCountry = "flag ".concat(code.toLowerCase());
      var hideCss = css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["display: none;"], ["display: none;"])));
      return jsx(components.SingleValue, __assign({
        className: classNameCountry,
        css: singleValueCss
      }, props), jsx("div", {
        css: hideCss
      }, props.children));
    };

    return {
      Option: SelectOption,
      Control: SelectControl,
      Input: SelectInput,
      ValueContainer: SelectValueContainer,
      SingleValue: SelectSingleValue,
      MenuList: SelectMenuList
    };
  }, [countryContainerCss, theme.fontSizes, theme.fonts.base, theme.colors.text.default]);
  var rootStyle = css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    position: relative; \n    border: 0.063rem solid ", "; \n    border-radius: 0.5rem;\n    height: 2.5rem;\n    margin-top: 1.05rem;\n    margin-bottom: 1.125rem;\n    &:hover {\n      border-color: ", ";\n      cursor: ", ";\n    }\n    &:hover>label {\n      color: ", "\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    position: relative; \n    border: 0.063rem solid ", "; \n    border-radius: 0.5rem;\n    height: 2.5rem;\n    margin-top: 1.05rem;\n    margin-bottom: 1.125rem;\n    &:hover {\n      border-color: ", ";\n      cursor: ", ";\n    }\n    &:hover>label {\n      color: ", "\n    }\n  "])), theme.colors.intent[intent].base, !disabled ? intent === 'none' ? theme.colors.scales.blue[5] : theme.colors.intent[intent].base : '', variant === 'country' || variant === 'select' ? 'pointer' : 'auto', !disabled ? intent === 'none' ? theme.colors.scales.blue[5] : theme.colors.intent[intent].base : '');
  return jsx(Component, {
    css: rootStyle
  }, variant === 'phone' && jsx(FlagsStyles, null), label ? jsx(Label, {
    id: id,
    theme: theme,
    label: label,
    intent: intent,
    variant: variant,
    placeholder: placeholder,
    animation: animation,
    defaultValue: defaultValue,
    value: value,
    labelStyles: labelStyles
  }) : null, variant === 'phone' && jsx(Select, __assign({}, controledCountryProp, {
    onChange: handleDialCodeChange,
    components: selectComponents,
    styles: countryStyles,
    isSearchable: false,
    defaultValue: countryInput,
    openMenuOnClick: true,
    placeholder: null,
    isOptionSelected: onOpenSelected ? onOpenSelected : undefined,
    onBlur: onCloseSelected ? onCloseSelected : undefined,
    isDisabled: disabled,
    classNamePrefix: 'custom',
    formatOptionLabel: function formatOptionLabel(option) {
      return "".concat(option.code);
    },
    options: countries,
    theme: function theme(_theme) {
      return __assign(__assign({}, _theme), {
        colors: __assign(__assign({}, _theme.colors), {
          primary: 'neutral10'
        })
      });
    },
    className: 'select-country'
  })), variant === 'country' && jsx("span", {
    css: [iconBeforeStyles, __assign({}, iconBeforeCss)]
  }, country === null || country === void 0 ? void 0 : country.flag), variant === 'phone' || variant === 'date' ? jsx("input", __assign({
    id: id,
    css: [variant === 'phone' ? {
      paddingLeft: '3rem'
    } : {
      paddingLeft: '0.313rem'
    }, {
      position: 'absolute',
      bottom: '0.6rem',
      width: '100%',
      paddingBottom: '0.063rem'
    }, gettedInputStyles, __assign({}, inputStyles), __assign({}, inputCss)],
    placeholder: variant === 'phone' ? "".concat((_c = searchCountry(dialCode ? dialCode : countryCode)) === null || _c === void 0 ? void 0 : _c.dialCode, " ").concat(phonePlaceholder) : placeholder,
    type: variant === 'phone' ? 'tel' : 'text',
    inputMode: variant === 'phone' ? 'tel' : 'text',
    disabled: disabled,
    value: inputDisplayedValue,
    onFocus: function onFocus(e) {
      setIsFocused(true);
      handlePhoneFocused();
      if (_onFocus) _onFocus(e);
    },
    onBlur: function onBlur(e) {
      setIsFocused(false);
      handlePhoneBlured();
      if (_onBlur) _onBlur(e);
    },
    onChange: handleChange
  }, safeBind({
    ref: ref
  }, rest))) : null, variant === 'currency' && jsx("input", __assign({
    id: id,
    css: [{
      paddingLeft: '0.313rem',
      position: 'absolute',
      bottom: '0.625rem',
      width: '100%'
    }, gettedInputStyles, __assign({}, inputStyles), __assign({}, inputCss)],
    value: inputDisplayedValue,
    placeholder: placeholder,
    disabled: disabled,
    type: 'currency',
    inputMode: 'numeric',
    onKeyPress: function onKeyPress(_a) {
      var key = _a.key;
      return setFocusNextInput(key, value, error);
    },
    onFocus: function onFocus(e) {
      if (_onFocus) _onFocus(e);
      setIsFocused(true);
    },
    onBlur: function onBlur(e) {
      if (_onBlur) _onBlur(e);
      setIsFocused(false);
      handleCurrencyBlur();
    },
    onChange: handleChange
  }, safeBind({
    ref: ref
  }, rest))), variant === 'select' && jsx("input", __assign({
    id: id,
    "data-selectbox": true,
    css: [{
      paddingLeft: '0.313rem',
      position: 'absolute',
      bottom: '0.625rem',
      width: '100%',
      cursor: 'pointer'
    }, gettedInputStyles, __assign({}, inputStyles), __assign({}, inputCss)],
    value: value,
    placeholder: placeholder,
    disabled: disabled,
    type: 'text',
    inputMode: 'text',
    onKeyPress: function onKeyPress(_a) {
      var key = _a.key;
      return setFocusNextInput(key, value, error);
    },
    onFocus: function onFocus(e) {
      setIsFocused(true);
      setOpened(true);
      if (_onFocus) _onFocus(e);
    },
    onBlur: function onBlur(e) {
      setTimeout(function () {
        setIsFocused(false);
        handleCurrencyBlur();
        setOpened(false);
      }, 300);
      if (_onBlur) _onBlur(e);
    },
    onChange: handleChange
  }, safeBind({
    ref: ref
  }, rest))), (variant === 'default' || variant === 'country') && jsx("input", __assign({
    id: id,
    css: [inputCss, variant === 'country' ? {
      position: 'absolute',
      bottom: '0.625rem',
      width: '100%',
      cursor: 'pointer'
    } : {
      position: 'absolute',
      bottom: '0.625rem',
      width: '100%'
    }, gettedInputStyles, {
      paddingLeft: '0.313rem'
    }, gettedInputStyles, __assign({}, inputStyles)],
    value: value || value === '' ? value : inputValue,
    placeholder: placeholder,
    disabled: disabled,
    onKeyPress: function onKeyPress(_a) {
      var key = _a.key;
      return setFocusNextInput(key, value, error);
    },
    onFocus: function onFocus(e) {
      setIsFocused(true);
      if (_onFocus) _onFocus(e);
    },
    onBlur: function onBlur(e) {
      setIsFocused(false);
      if (_onBlur) _onBlur(e);
    },
    onChange: handleChange
  }, safeBind({
    ref: ref
  }, rest))), caption && jsx("span", {
    css: captionStyles
  }, caption), value && (value === null || value === void 0 ? void 0 : value.length) > 0 && !disabled && variant !== 'country' ? jsx("i", {
    css: [iconAfterStylesErase, __assign({}, iconAfterCss)],
    onClick: function onClick() {
      if (setEraseValue) {
        setEraseValue();
        setInputDisplayedValue('');
        setInputValue('');
      }
    }
  }, eraseImg) : null, !caption && iconAfter && jsx("i", {
    css: [iconAfterStyles, __assign({}, iconAfterCss)],
    onClick: function onClick() {
      if (onClickAfterIcon) onClickAfterIcon();
      if (variant === 'select') setOpened(true);
    }
  }, iconAfter), (variant === 'select' || variant === 'country') && jsx("i", {
    "data-selectbox": true,
    css: [iconAfterStyles, __assign({}, iconAfterCss)],
    onClick: function onClick() {
      if (onClickAfterIcon) onClickAfterIcon();

      if (variant === 'select') {
        handleArrowInteraction(String(id));
      }
    }
  }, arrowDown), variant === 'select' && opened && onSelectItem ? jsx("div", {
    "data-selectbox": true,
    css: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n            position: absolute;\n            margin-top: 3rem;\n            box-shadow: 0 0.125rem 0.5rem rgba(2, 18, 21, 0.1);\n            background-color: ", ";\n            border-radius: 0.25rem;\n            width: 100%;\n            z-index: ", ";\n          "], ["\n            position: absolute;\n            margin-top: 3rem;\n            box-shadow: 0 0.125rem 0.5rem rgba(2, 18, 21, 0.1);\n            background-color: ", ";\n            border-radius: 0.25rem;\n            width: 100%;\n            z-index: ", ";\n          "])), isDarkMode ? theme.colors.scales.grayShades[10] : theme.colors.scales.grayShades[0], dropdownIndex ? dropdownIndex : '999999')
  }, initItems === null || initItems === void 0 ? void 0 : initItems.map(function (el) {
    return jsx("div", {
      onClick: function onClick() {
        onSelectItem(el.title);
        setOpened(false);
      },
      key: el.title,
      css: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n              color: ", ";\n              display:flex;\n              height:2.5rem;\n              align-items:center;\n              font-family: ", ";\n              vertical-align:center;\n              padding-left:0.875rem;\n              &:hover{\n                background-color: ", ";\n                cursor: pointer;\n              }\n            "], ["\n              color: ", ";\n              display:flex;\n              height:2.5rem;\n              align-items:center;\n              font-family: ", ";\n              vertical-align:center;\n              padding-left:0.875rem;\n              &:hover{\n                background-color: ", ";\n                cursor: pointer;\n              }\n            "])), isDarkMode ? theme.colors.scales.grayShades[0] : theme.colors.scales.grayShades[10], theme.fonts.base, isDarkMode ? theme.colors.scales.grayShades[9] : theme.colors.scales.grayShades[1])
    }, el.title);
  })) : null, helper && jsx("span", {
    css: [gettedHelperStyles, __assign({}, helperStyles)]
  }, helper));
};
InputTextComponent.displayName = 'Input';
export var InputText = React.forwardRef(InputTextComponent);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;